var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 3,
    viewBox: "0 0 12 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#6C757D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.92383,
    cy: 1.5,
    r: 1.5,
    fill: "#6C757D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3477,
    cy: 1.5,
    r: 1.5,
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.94b9c51f6c8548f46600a4119eb05e40.svg";
export { ForwardRef as ReactComponent };